import Cookies from 'js-cookie'

export function addCookie(key, vulue, effectTime) {
    Cookies.set(key, vulue, {
        expires: effectTime
    });
}

export function addLoginCookie(vulue) {
    Cookies.set('_ctx', vulue);
}

export function clearCookie(key) {
    Cookies.set(key, '', -1);
}

export function getToken() {
    return Cookies.get('_ctx');
}

export function getTokenForKey(key) {
    return Cookies.get(key);
}


// WEBPACK FOOTER //
// ./src/utils/cookieOper.js